import { SoffLogMessagePermission, SoffWorkOrderPermission, TSC_ONLY, TscPermission } from '../../models/account/auth.model.sto';
import { DsmLicenseEnum } from '../../models/account/workshop.sto';
import { Features } from '../../models/feature-toggle.model';

export interface SideNavigationItem {
  icon: string;
  labelI18nKey: string;
  routerLink: string;
  dsmLicenseNeeded?: (keyof typeof DsmLicenseEnum)[];
  permissionNeeded?: string[];
  negatedPermission?: string[];
  isProductionReady?: boolean;
  featureToggleNeeded?: string;
}

export const SideNavigationItems: SideNavigationItem[] = [
  {
    icon: 'incoming-topics.svg',
    labelI18nKey: 'global.navigation.incomingTopics',
    routerLink: '/app/incoming-topics',
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'work-orders.svg',
    labelI18nKey: 'global.navigation.work-orders',
    routerLink: '/app/field-service/work-orders',
    dsmLicenseNeeded: [DsmLicenseEnum.PRO, DsmLicenseEnum.PLUS],
    isProductionReady: true,
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'calendar.svg',
    labelI18nKey: 'global.navigation.calendar',
    routerLink: '/app/field-service/resource-planning',
    dsmLicenseNeeded: [DsmLicenseEnum.PRO, DsmLicenseEnum.PLUS],
    permissionNeeded: [SoffWorkOrderPermission.WORKORDER_CREATE],
    isProductionReady: true,
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'machines.svg',
    labelI18nKey: 'global.navigation.machines',
    routerLink: '/app/machines/index/list',
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'employees.svg',
    labelI18nKey: 'global.navigation.employees',
    routerLink: '/app/employees',
    dsmLicenseNeeded: [DsmLicenseEnum.PRO, DsmLicenseEnum.PLUS],
    isProductionReady: true,
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'customers.svg',
    labelI18nKey: 'global.navigation.customers',
    routerLink: '/app/customers',
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'servicevans.svg',
    labelI18nKey: 'global.navigation.servicevans',
    routerLink: '/app/servicevans',
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'technical-documentation.svg',
    labelI18nKey: 'global.navigation.technicalDocumentation',
    routerLink: '/app/technical-documentation',
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'log-messages.svg',
    labelI18nKey: 'global.navigation.logMessages',
    routerLink: '/app/log-messages',
    dsmLicenseNeeded: [DsmLicenseEnum.PRO],
    permissionNeeded: [SoffLogMessagePermission.LOGMESSAGE_READ],
    isProductionReady: true,
    featureToggleNeeded: Features.DMS_LOG_MESSAGES,
    negatedPermission: TSC_ONLY,
  },
  {
    icon: 'technical_support_center.svg',
    labelI18nKey: 'Tickets',
    routerLink: '/app/tickets',
    permissionNeeded: [TscPermission.TICKET_VIEW], // only visible for TSC user
  },
  // {
  //     icon:           'technical-documentation.svg',
  //     labelI18nKey:   'global.navigation.privacy',
  //     routerLink:     '/app/privacy/en'
  // },
  // {
  //     icon:           'technical-documentation.svg',
  //     labelI18nKey:   'global.navigation.disclaimer',
  //     routerLink:     '/app/terms-of-use/en'
  // },
];
